import React, {Component} from 'react';
import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Web_main from './components/Web_main';
import Footer from './components/Footer.js';
import {BrowserView, mobileModel} from 'react-device-detect';

class App extends Component{
  constructor(props){
    super(props)
    this.state={
    }
  }

  componentDidMount(){
    //console.log(window.location.href)
    function Mobile() {return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);}
    //console.log(Mobile()) // 콘솔창에서 확인 가능
     if(Mobile()){
       //모바일페이지
       window.location.replace('http://m.dodacmamma.co.kr/') 
     }
  }

  render(){
    return(
      <div className='App'>
        <BrowserView>
          <BrowserRouter>
          <Routes>
            <Route exact path='/' element={<Web_main/>}/>
          </Routes>
          <Footer/>
          </BrowserRouter>
        </BrowserView>
      </div>
    )
  }
}

export default App;